import React from 'react'

export default function RetryError({ message = '문제가 발생했습니다', onRetry, className = '' }) {
    return (
        <div className={`p-4 text-sm bg-red-50 border border-red-200 rounded flex items-center justify-between ${className}`}>
            <div className="text-red-700 mr-3">{message}</div>
            {onRetry && (
                <button className="text-red-700 underline" onClick={onRetry}>다시 시도</button>
            )}
        </div>
    )
}
